<c-container class="mt-5">
  <h2>Active Causable draws</h2>
  <p class="intro">Open a draw below, or switch to a game with the game menu at the top of the page.</p>

  @if (uiState() === UIStateEnum.ShowLoading) {
    <mat-spinner class="center-margin"></mat-spinner>
  } @else if (cards().length === 0) {
    <p data-testid="no-active-draws">No game has a draw running.</p>
  } @else {
    <div class="draw-grid" data-testid="active-draw-list">
      @for (card of cards(); track card.game.Id) {
        <mat-card class="draw-card"
                  role="button"
                  tabindex="0"
                  (click)="openDraw(card)"
                  (keydown.enter)="openDraw(card)"
                  (keydown.space)="$event.preventDefault(); openDraw(card)"
                  [attr.data-game-id]="card.game.Id"
                  data-testid="active-draw-card">
          <div class="draw-card-logo" [class.dark]="card.game.GameThemeTypeId === GameThemeType.Dark && !missingLogos().has(card.game.Id)">
            @if (missingLogos().has(card.game.Id)) {
              <mat-icon class="logo-placeholder">sports_esports</mat-icon>
            } @else {
              <img [src]="logoUrl(card)" [alt]="card.game.Name + ' logo'" (error)="logoFailed(card)" data-testid="active-draw-logo"/>
            }
          </div>
          <div class="draw-card-header">
            <h3 [attr.title]="card.game.Name" data-testid="active-draw-game-name">{{ card.game.ShortName || card.game.Name }}</h3>
            <span class="game-type">{{ card.draw.Type === GameTypeEnum.GoldRush ? 'Gold Rush' : '50/50' }}</span>
          </div>
          <div class="draw-card-figures">
            <div>
              <div class="figure-label">Next Draw</div>
              <div class="figure-value" data-testid="active-draw-next-draw">
                {{ card.draw.State === GameInstanceStatuses.ReadyForDraw ? 'Ready for Draw' : countdown(card) }}
              </div>
            </div>
            <div>
              <div class="figure-label">Current Pot</div>
              <div class="figure-value" data-testid="active-draw-pot">{{ card.draw.PotTotal | formatCurrency }}</div>
            </div>
          </div>
        </mat-card>
      }
    </div>
  }
</c-container>
